// `video.upscale`: live's Video Upscale tool (#211).
// Live's label map (`UPSCALE_VIDEO`); the tool's own form builds the body.
import { VideoUpscaleQuote, VideoUpscaleRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.upscale"> = {
  type: "video.upscale",
  label: "Video Upscale",
  source: "form",
  pair: "video.upscale",
  fields: () => ({}),
  request: VideoUpscaleRequest,
  quote: VideoUpscaleQuote,
};
